import { useEffect, useState } from "react";
import { PageHeader, NativeSelect } from "@/components/common";
import { UsersManager } from "@/components/UsersManager";
import { RevisionScopeButton } from "@/components/RevisionScopeButton";
import { CollectorTenantsButton } from "@/components/CollectorTenantsButton";
import { api } from "@/lib/api";

export default function AdminUsers() {
  const [tenants, setTenants] = useState([]);
  const [filter, setFilter] = useState("");
  useEffect(() => {
    api.get("/admin/tenants").then((r) => setTenants(r.data));
  }, []);
  return (
    <div>
      <PageHeader sheet="ADMIN 03" title="Pengguna & Hak Akses" subtitle="Kelola semua akun: admin utama, pemilik, admin rekap, operator, dan viewer.">
        <NativeSelect value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="admin-users-tenant-filter">
          <option value="">Semua perusahaan</option>
          {tenants.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </NativeSelect>
      </PageHeader>
      <UsersManager apiBase="/admin/users" roles={["owner", "admin", "operator", "viewer", "supervisor", "collector", "superadmin"]} tenants={tenants} filterTenant={filter}
        extra={(u, reload) => (u.platform_role === "supervisor" ? <RevisionScopeButton user={u} tenants={tenants} onDone={reload} />
          : u.platform_role === "collector" ? <CollectorTenantsButton user={u} tenants={tenants} onDone={reload} /> : null)} />
    </div>
  );
}
